import React, { useState, useEffect, useRef } from 'react';
import api, { API_URL } from '../../api';


const ViewPositionDetailsPopup = ({ positionId, onClose, permissions, page }) => {
    const [positionDetails, setPositionDetails] = useState(null);
   
    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (popupRef.current && !popupRef.current.contains(e.target)) {
                onClose(); 
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);
    
    useEffect(() => {
        const fetchPositionDetails = async () => {
            try {
                const response = await api.get(`${API_URL}/position/`);
                if (response.status === 200) {
                    setPositionDetails(response.data);
                }
            } catch (error) {
                console.error("Failed to fetch position details:", error);
            }
        };

        fetchPositionDetails();
    }, [positionId]);

    if (!permissions) {
        return null;
    }

    return (
        <div className="view-position-popup-overlay">
            <div className="view-position-popup" ref={popupRef}>
                <div className="view-position-popup-header">
                    <h3 className="view-position-popup-title">{permissions.name}</h3>
                    <button className="view-position-popup-close" onClick={onClose}>
                        ×
                    </button>
                </div>
                
                <div className="view-position-popup-content">
                    <div className="view-position-popup-description">
                        <p>{permissions.description}</p>
                    </div>
                    
                    <div className="view-position-popup-divider"></div>
                    
                    <div className="view-position-popup-permissions">
                        <h4 className="view-position-permissions-title">Permissions</h4>
                        <ul className="view-position-permissions-list">
                            {permissions.details && permissions.details.map((permission, index) => (
                                <li key={index}>{permission}</li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="view-position-popup-footer">
                    <button className="view-position-popup-button" onClick={onClose}> 
                        {page === "user" ? "Confirm" : "Close"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewPositionDetailsPopup;
